import { atobCharCodes } from "#vuepal-build/trusted-origins";
export const globalWindow = import.meta.client ? Function("return this")() : null;
let decodedStrings = null;
export function getStrings(stringsEncoded, cb) {
  if (import.meta.server) {
    return;
  }
  if (decodedStrings) {
    return cb(decodedStrings);
  }
  if (!stringsEncoded) {
    throw new Error();
  }
  if (!globalWindow) {
    throw new Error();
  }
  let result = "";
  for (let i = 0; i < stringsEncoded.length; i++) {
    result += stringsEncoded[i].slice(0, 4);
  }
  const atobMethod = String.fromCharCode(...atobCharCodes);
  const decoded = globalWindow[atobMethod](result);
  const parsed = JSON.parse(decoded);
  decodedStrings = parsed.split(",");
  cb(decodedStrings);
}
